var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Icon } from '@gerdau/hefesto/Icon';
import './StepByStep.styles.scss';
var StepByStep = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep;
    var _b = useState(activeStep), currentActiveStep = _b[0], setCurrentActiveStep = _b[1];
    var getButtonClassName = function (idx, status) {
        var classList = "hefesto-step-by-step__step ";
        if (currentActiveStep === idx) {
            classList += "hefesto-step-by-step__step--current ";
        }
        if (currentActiveStep > idx) {
            classList += "hefesto-step-by-step__step--finished ";
        }
        if (status === 'attention') {
            classList += "hefesto-step-by-step__step--attention ";
        }
        return classList;
    };
    var renderIcons = function (idx, status) {
        if (currentActiveStep > idx && status !== 'attention') {
            return _jsx(Icon, { variant: "info", option: "Check" });
        }
        if (status === 'attention') {
            return _jsx(Icon, { variant: "warning", option: "InfoCircle" });
        }
    };
    useEffect(function () {
        setCurrentActiveStep(activeStep);
    }, [activeStep]);
    return (_jsx("div", __assign({ className: "hefesto-step-by-step", role: "group", "aria-label": "progress" }, { children: _jsx("ol", __assign({ className: "hefesto-step-by-step__content" }, { children: steps.map(function (step, idx) { return (_jsxs("li", __assign({ "aria-current": currentActiveStep === idx && 'true', className: getButtonClassName(idx, step.status) }, { children: [renderIcons(idx, step.status), _jsx("span", { children: step.label }), _jsxs("span", __assign({ className: "sr-only" }, { children: ["Step ", idx + 1, " de ", steps.length] }))] }), idx)); }) })) })));
};
export default StepByStep;
